import React, { useEffect } from "react"
import PropTypes from "prop-types"
import Modal from "@kit/design/modal"
import { PlanSwitchConfirmation } from "./plan-switch-confirmation"
import { analytics } from "utils/analytics"

export function PlanSwitchConfirmationModal({
  label,
  onClose,
  fromPlan,
  toPlan,
  onCancel,
  onConfirm,
  disableButton,
  message,
  tracking = {}
}) {
  const { location } = tracking

  useEffect(() => {
    analytics.track("Element", "Opened", {
      element_type: "modal",
      name: "plan_switch_confirmation",
      label: label,
      location: location,
      from_plan: fromPlan.display_name,
      to_plan: toPlan.display_name
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      label={label}
      onClose={onClose}
      data-testid="plan-switch-confirmation-modal"
    >
      <PlanSwitchConfirmation
        fromPlan={fromPlan}
        toPlan={toPlan}
        onCancel={onCancel}
        onConfirm={onConfirm}
        disableButton={disableButton}
        message={message}
      />
    </Modal>
  )
}

PlanSwitchConfirmationModal.propTypes = {
  label: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  fromPlan: PropTypes.object.isRequired,
  toPlan: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  disableButton: PropTypes.bool,
  message: PropTypes.string,
  tracking: PropTypes.shape({
    location: PropTypes.string
  })
}
